<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FxCxpe/tc-custom/9781466880337.jpg?1737197407539" alt="This image is the cover for the book Dream on Monkey Mountain and Other Plays"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dream on Monkey Mountain and Other Plays
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Four acclaimed plays by the Nobel laureate, including his Obie Award-winning “masterpiece” (</b><i><b>The New Yorker</b></i><b>). </b></p><p>In <i>Dream on Monkey Mountain</i>, a poor hermit on a Caribbean island tears through the market in a drunken rage. Taken away to sober up in jail, he dreams he has become a healer, walking from village to village and tending to the sick. His companion seeks to exploit his power. Yet the half awake hermit is determined to heal his deceitful friend, his jailer, and his jail-mates—and to become a leader for his people. <br/><br/>Three of Derek's Walcott's most popular short plays are also included in this volume: <i>Ti-Jean and His Brothers</i>; <i>Malcochon, or The Six in the Rain</i>; and <i>The Sea at Dauphin</i>. In an expansive introductory essay, "What the Twilight Says," the playwright explains his founding of the seminal dramatic company where these works were first performed, the Trinidad Theatre Workshop.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Derek Walcott
      </h2>
      
      <p class="authorDescription body article"><B>Derek Walcott (1930-2017)</B> was born in St. Lucia, the West Indies, in 1930. His <I>Collected Poems: 1948-1984</I> was published in 1986, and his subsequent works include a book-length poem, <I>Omeros </I>(1990); a collection of verse, <I>The Bounty</I> (1997); and, in an edition illustrated with his own paintings, the long poem <I>Tiepolo's Hound</I> (2000). His numerous plays include <I>The Haitian Trilogy</I> (2001) and <I>Walker and The Ghost Dance</I> (2002). Walcott received the Queen's Medal for Poetry in 1988 and the Nobel Prize in Literature in 1992.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5da79c4f